export default "__VITE_ASSET__JebV1QAMMrxp2AO26tQsjg__"